import React from 'react';
import PropTypes from 'prop-types';
import { useFormStatus } from 'react-hooks-form';
import Button from 'packages/ui/Button';

function Submit({ text, ...rest }) {
  const { submitting } = useFormStatus();

  return (
    <Button type="submit" {...rest} working={submitting}>
      {text}
    </Button>
  );
}

Submit.propTypes = {
  text: PropTypes.string
};

Submit.defaultProps = {
  text: 'ذخیره'
};

export default Submit;
